var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._g(_vm._b({attrs:{"value":_vm.coordinateText}},'el-input',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }